import { useEffect, useRef, useState } from "react";

/**
 * Révélation douce au scroll (IntersectionObserver). Respecte prefers-reduced-motion.
 */
export function useReveal(options = {}) {
  const { threshold = 0.12, rootMargin = "0px 0px -8% 0px" } = options;
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    if (typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setVisible(true);
      return;
    }

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          io.disconnect();
        }
      },
      { threshold, rootMargin }
    );

    io.observe(el);
    return () => io.disconnect();
  }, [threshold, rootMargin]);

  return { ref, visible };
}
